/**
 * Sub1 Template
 * @category testApp
 */
class PagingTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {Object} _config={}
     */
    static getPagingTempl(_d={}, _config={}) {
        let itmes = ``, markup='', startNum = 1, max = 1, arr = [];
        startNum = Math.floor(((_d.pagination.page-1) / 5)) * 5 + 1;
        max = startNum+4;
        if(max >= _d.pagination.endPage) max = _d.pagination.endPage;
        for(let i = startNum; i <= max; i++){
            itmes += `
            <a href="javascript:void(0)" data-page-value="${i}" class="ui-paging-num ${(_d.pagination.page == i) ? 'is-active' : ''}">${i}</a>
            `;
        }
        markup = `
            <a ${(startNum <= 5)? 'disabled': `href="javascript:void(0)"`} data-page-value="${startNum-1}" class="ui-paging-arrow is-prev"></a>
                ${itmes}
            <a ${(max >= _d.pagination.endPage)? 'disabled': `href="javascript:void(0)"`} data-page-value="${max+1}" class="ui-paging-arrow is-next"></a>
        `;
        return `
            ${markup}
        `;
    }
} // end of class

export default PagingTempl;